export default __webpack_public_path__ + "static/fullstack-career-banner-3c965ea2a2f46ae3271d46cd09b1573a.jpg";